import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../util/patterns";
import * as services from "../../store/service";
import { Notification } from "../common/Notification";
import * as LoginActions from "../../store/loginService/actions";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next'

const ResendActivationMailDialog: React.FunctionComponent<{ closeDialog(): void; email: string; subcustomerId: string; firstName: string; lastName: string }> = (
    props
) => {
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();
    const [isLoading, setisLoading] = useState(false);
    const [email, setEmail] = useState(props.email);
    const getFamilyMembers = () => dispatch(LoginActions.actionCreators.getFamilyMembers(true));
    const { register, errors, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    function onChangeHandler(event: any) {
        setEmail(event.currentTarget.value);
    }

    const sendEmail = () => {
        const requestBody = {
            "resend-registration-email": true,
            "email-address": email,
            subcustomerId: props.subcustomerId,
        };

        setisLoading(true);
        services
            .updateFamilyAccountEmail(requestBody)
            .then((data) => {
                setisLoading(false);
                getFamilyMembers();
                if (!data.hasError && data.message && data.message === "Success") {
                    Notification({
                        type: "success",
                        title: tLang("manageAccount.myAccount.familyProtection.toastMsgs.resendActivationEmail.title"),
                        message: tLang("manageAccount.myAccount.familyProtection.toastMsgs.resendActivationEmail.successMsg", {email: email}),
                        duration: 5,
                    });
                } else {
                    const errorMessage =
                        data.message && data.message === "UEMAIL2"
                            ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.resendActivationEmail.errorMsg1")
                            : tLang("manageAccount.myAccount.familyProtection.toastMsgs.resendActivationEmail.errorMsg2");

                    Notification({
                        type: "error",
                        title: tLang("manageAccount.myAccount.familyProtection.toastMsgs.resendActivationEmail.title"),
                        message: errorMessage,
                        duration: 5,
                    });
                }
                closeDialog();
            })
            .catch(() => {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: tLang("manageAccount.myAccount.familyProtection.toastMsgs.resendActivationEmail.title"),
                    message: tLang("manageAccount.myAccount.familyProtection.toastMsgs.resendActivationEmail.errorMsg2"),
                    duration: 5,
                });
                closeDialog();
            });
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className="las la-user-plus"></em>
                        </div>
                        <h1>{tLang("manageAccount.myAccount.familyProtection.resendActivationEmailText")}</h1>
                        <p>{tLang("manageAccount.myAccount.familyProtection.resendActivationEmailStatement", { name: props.firstName + " " + props.lastName })}</p>
                    </div>

                    <form onSubmit={handleSubmit(sendEmail)} id="add-fps-form-container">
                        <div className="dialog-body">
                            <div className={errors["email"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-email">{tLang("manageAccount.myAccount.familyProtection.emailAddressLabel")} </label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            id="edit-email"
                                            aria-labelledby="edit-email"
                                            name="email"
                                            defaultValue={email}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: PATTERNS.EMAIL.pattern,
                                            })}
                                            maxLength={PATTERNS.EMAIL.maxLength}
                                        />
                                        {errors.email && errors.email.type === "pattern" && <span className="form-error">{tLang(PATTERNS.EMAIL.message)}</span>}

                                        {errors.email && errors.email.type === "required" && <span className="form-error">{tLang("manageAccount.myAccount.familyProtection.validationMsgs.email.required")}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                        <span className="btn-text">{tLang("manageAccount.myAccount.familyProtection.cancelBtnText")}</span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary">
                                        <span className="btn-text">{tLang("manageAccount.myAccount.familyProtection.resendText")}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default ResendActivationMailDialog;
